import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=b299d3f4&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=b299d3f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b299d3f4",
  null
  
)

export default component.exports